import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaEdit,
  FaStar,
  FaRocket,
  FaMobileAlt,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const VideoEditingServicesInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Video Editing Services in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Polish Your Vision</Subheading>}
        heading={
          <Heading>
            Video Editing <span tw="text-primary-500">Services</span> in Bur
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we provide expert video editing services in **Bur
            Dubai**, transforming raw footage into polished, engaging content
            for businesses, creators, and events.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1574375927938-d5a98e8ffe85?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Video editing on computer
          "https://images.unsplash.com/photo-1535016120720-40c646be5580?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Professional editing suite
          "https://images.unsplash.com/photo-1542744094-3a31f272c490?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Creative editing workspace
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Enhance Your Video Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Professional Video Editing in Bur Dubai"
        description="We elevate your footage to the next level."
        cards={[
          {
            icon: <FaEdit color="#ff5464" size={40} />,
            title: "Precision Editing",
            description: "Seamless cuts, transitions, and effects.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "High-Quality Output",
            description: "Crisp visuals and immersive audio.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Quick delivery to meet your deadlines.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description: "Optimized for YouTube, social media, and more.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Clients",
            description: "Bur Dubai’s choice for video editing.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Custom Solutions",
            description: "Tailored for ads, vlogs, or events.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Video Editing Process"
        description={
          <Description>
            We refine your footage with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your project goals and style.</li>
              <li>Review: Analyze your raw footage for potential.</li>
              <li>Editing: Craft a narrative with cuts, effects, and audio.</li>
              <li>Enhancement: Add color grading, text, and branding.</li>
              <li>Delivery: Provide polished videos ready to share.</li>
              <li>Support: Offer revisions for perfect results.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1542744095-fcf48d80b0fd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Editor workspace
          "https://images.unsplash.com/photo-1626785774573-4b799315345d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Post-production work
          "https://images.unsplash.com/photo-1551033406-611cf9a28f67?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Video editing software
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Video Editing Wins in Bur Dubai"
        description="Our editing has transformed projects."
        cards={[
          {
            icon: <FaEdit color="#ff5464" size={40} />,
            title: "Engaging Content",
            description: "Turned raw footage into viral videos.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% approval from Bur Dubai clients.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Brand Impact",
            description: "Enhanced ads and promos for success.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Elevate Your Videos?</Subheading>}
        heading="Video Editing Services in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert video editing services in Bur
            Dubai. Get polished, professional content to captivate your
            audience—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1592478411213-6153e4ebc07d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Professional editing setup
          "https://images.unsplash.com/photo-1633613286848-e6f43bbafb8d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Video editing process
          "https://images.unsplash.com/photo-1576183636102-30e932c542d2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Editing monitors
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
